<template>
  <!-- What a click (or a drag) on the empty grid can add there. Anchored at the
       pointer, in the body's coordinates, so it is never clipped by the grid's
       horizontal scroll container. -->
  <ul class="tt-menu tt-slot-menu tt-surface shadow" role="menu" ref="menu"
      v-bind:style="{ left: left + 'px', top: top + 'px' }">
    <li class="tt-menu__label tt-slot-menu__header">
      <span>{{ label }}</span>
      <!-- Tapping outside also closes it, but nothing said so; on a phone, where
           there is no Escape, this is the only visible way out. -->
      <button type="button" class="tt-icon-btn tt-icon-btn--round tt-slot-menu__close"
              v-bind:title="texts.cancel || 'Renunță'"
              v-bind:aria-label="texts.cancel || 'Renunță'"
              @click.stop.prevent="$emit('close')">
        <i class="icon-close" aria-hidden="true"></i>
      </button>
    </li>
    <li class="tt-menu__item" role="none">
      <a role="menuitem" @click.stop.prevent="$emit('pick', 'event')">
        <hero-icon name="calendar-days"></hero-icon>
        <strong>{{ texts.slot_menu_event || 'Eveniment' }}</strong>
      </a>
    </li>
    <li class="tt-menu__item" role="none">
      <a role="menuitem" @click.stop.prevent="$emit('pick', 'reservation')">
        <hero-icon name="lock-closed"></hero-icon>
        <strong>{{ texts.slot_menu_reservation || 'Rezervare' }}</strong>
      </a>
    </li>
  </ul>
</template>

<script>
import HeroIcon from "./HeroIcon.vue";

const VIEWPORT_MARGIN = 8;

export default {
  name: "SlotMenu",

  components: { "hero-icon": HeroIcon },

  props: {
    // Pointer position the menu opens at (viewport coordinates).
    x: { type: Number, required: true },
    y: { type: Number, required: true },
    label: { type: String, default: "" },
    texts: { type: Object, default: () => ({}) },
  },

  data() {
    return { left: this.x, top: this.y };
  },

  mounted() {
    // Opened near an edge, the menu is pulled back in so every item stays reachable.
    this.$nextTick(() => {
      const rect = this.$refs.menu.getBoundingClientRect();
      this.left = Math.max(VIEWPORT_MARGIN, Math.min(this.x, window.innerWidth - rect.width - VIEWPORT_MARGIN));
      this.top = Math.max(VIEWPORT_MARGIN, Math.min(this.y, window.innerHeight - rect.height - VIEWPORT_MARGIN));
    });

    // Registered after the click that opened us has finished bubbling, so it
    // cannot close the menu it just opened.
    setTimeout(() => {
      document.addEventListener("click", this.onDocumentClick);
      document.addEventListener("keydown", this.onKeydown);
    }, 0);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
  },

  methods: {
    onDocumentClick(domEvent) {
      if (this.$refs.menu && this.$refs.menu.contains(domEvent.target)) return;
      this.$emit("close");
    },

    onKeydown(domEvent) {
      if (domEvent.key === "Escape") this.$emit("close");
    },
  },
};
</script>
